import React, {Fragment} from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import posed, {PoseGroup} from 'react-pose';
import {Helmet} from "react-helmet";
import Home from "./home/Home";
import Resume from './my-resume/Resume';
import {BASE_PATH, HOME_PATH, LOGO_PATH, RESUME_PATH} from "../Constants/Constants";

export const AnimatedDiv = posed.div({
	enter: {
		// x: "100%",
		opacity: 1,
		transition: {
			duration: 200
		}
	},
	exit: {
		// x: "-100%",
		opacity: 0,
		transition: {
			duration: 200,

		}
	}
});

const RoutesContainer = posed.div({
	enter: {
		// y: 0,
		// x: '0%',
		opacity: 1,
		// delay: 200,
		// duration: 400,
		// transition: {type: 'tween', ease: 'easeInOut'}
	},
	exit: {
		// y: 200,
		// x: '100%',
		opacity: 0,
		// duration: 400,
		// transition: {type: 'tween', ease: 'easeInOut'}
	}
});


class Main extends React.Component {

	constructor(props) {
		super(props);
		//console.log(props);
		this.state = {
			window_width: 0,
			window_height: 0
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentWillMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentDidMount() {
		// this.updateWindowDimensions();
		// window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		this.setState({window_width: window.innerWidth, window_height: window.innerHeight});
		//console.log(window.innerWidth);
	}


	render() {

		const title = "Lalit Jain | Computer Science Student | Web Developer | Machine Learning Enthusiast";
		const description = "Lalit Jain is a Computer Science student at GGS Indraprastha University, New Delhi. He is also into Web Development and Machine Learning.";
		const url = "https://lalitjain.me";
		const imageLarge = "https://user-images.githubusercontent.com/26302274/55288861-7822ca80-53db-11e9-9f0c-9e816bd2da23.jpg";
		const imageSmall = "https://user-images.githubusercontent.com/26302274/55289210-08174300-53e1-11e9-9cc5-bca2cea75723.jpg";
		const twitterHandle = "@jainlalit138";


		const resume = (null);
		const home = (null);

		let head = (
			<Helmet>
				<link rel="shortcut icon" href={LOGO_PATH}/>
				<meta name="title" content={title}/>
				<meta name="description" content={description}/>
				<meta name="og:title" property="og:title" content={title}/>
				<meta name="og:description" property="og:description" content={description}/>
				<meta property="og:url" content={url}/>
				<meta property="og:image" content={imageLarge}/>
				<meta name="twitter:card" content="summary"/>
				<meta name="twitter:card" content="summary_large_image"/>
				<meta name="twitter:site" content={twitterHandle}/>
				<meta name="twitter:title" content={title}/>
				<meta name="twitter:description" content={description}/>
				<meta name="twitter:image" content={imageSmall}/>
				<meta name="google-site-verification" content="J2Exx8UzJYMDx5q-nUyh5Y5iUIA3IKTDwJfIyc-u_Uc"/>
				<title>{title}</title>
			</Helmet>
		);

		return (
			<div>
				{/*<Switch>*/}
				{/*	<Route key="home" exact path={"/"} component={() => home}/>*/}
				{/*	<Route key="my-resume" exact path={RESUME_PATH} component={() => resume}/>*/}
				{/*	/!*<Route component={() => home}/>*!/*/}
				{/*	<Redirect key="redirect" to={"/"}/>*/}
				{/*</Switch>*/}

				<Route render={
					({location}) => {
						//console.log("In Main Route");
						//console.log("Location: ");
						
						return (
							<Fragment>
								{head}
								<PoseGroup>
									<RoutesContainer key={location.pathname}>
										<Switch>
											<Route key="home" exact path={BASE_PATH} component={() => (
												<Home window_width={this.state.window_width}
															window_height={this.state.window_height}
															location={location}/>
											)}/>
											<Route key="my-resume" exact path={RESUME_PATH} component={() => (
												<Resume
													window_width={this.state.window_width}
													window_height={this.state.window_height}
													location={location}
													updateNavbarHeight={this.props.updateNavbarHeight}
												/>)}/>
											{/*<Route component={() => home}/>*/}
											<Redirect key="redirect" to={BASE_PATH}/>
										</Switch>
										{/*<Switch>*/}
										{/*	<Route key="home" exact path={HOME_PATH} component={() => home}/>*/}
										{/*	<Route key="my-resume" exact path={RESUME_PATH} component={() => resume}/>*/}
										{/*	<Redirect key="redirect" to={HOME_PATH}/>*/}
										{/*</Switch>*/}
									</RoutesContainer>
								</PoseGroup>
							</Fragment>
						)
					}
				}/>
			</div>
		);
	}
}

export default Main;